import { SimplePointSymbol } from "../symbol/symbol";
import { Renderer } from "./renderer";
import { GeometryType } from "../geometry/geometry";
import { ClusterSymbol } from "../symbol/cluster-symbol";
/**
 * 聚合渲染
 */
export class ClusterRenderer extends Renderer {
    constructor() {
        super(...arguments);
        /**
         * 默认渲染符号
         */
        this._defaultSymbol = new SimplePointSymbol();
        /**
         * 聚类容差距离
         */
        this._tolerance = 50; //distance 50px
        /**
         * 聚合要素集
         */
        this._features = {}; // Map<id, count>
    }
    /**
     * 设置数据源
     */
    set featureClass(value) {
        if (value.type == GeometryType.Point) {
            this._featureClass = value;
        }
    }
    /**
     * 设置默认符号
     */
    set defaultSymbol(value) {
        this._defaultSymbol = value;
    }
    /**
     * 设置容差
     */
    set tolerance(value) {
        this._tolerance = value;
    }
    /**
     * 根据矢量要素获取渲染符号
     * @param {ScreenBounds} redrawBounds - 屏幕范围
     * @remark Do something before layer draw, etc ClusterRenderer
     */
    init(redrawBounds) {
        this._features = {};
        if (!this._featureClass)
            return;
        let feature = this._featureClass.first;
        while (feature) {
            if (!redrawBounds || (feature.geometry && feature.geometry.screenBounds && feature.geometry.screenBounds.intersects(redrawBounds))) {
                let exist = false;
                const keys = Object.keys(this._features);
                for (let i = 0; i < keys.length; i++) {
                    const id = keys[i];
                    const item = this._featureClass.getFeature(id);
                    if (item) {
                        const p1 = feature.geometry;
                        const p2 = item.geometry;
                        if (p1.distance(p2) <= this._tolerance) {
                            exist = true;
                            this._features[id] += 1;
                            break;
                        }
                    }
                }
                if (!exist) {
                    this._features[feature.id] = 1;
                }
            }
            feature = feature.next;
        }
    }
    /**
     * 根据矢量要素获取渲染符号
     * @param {Feature} feature - 矢量要素
     * @return {Symbol} 返回渲染符号
     */
    getSymbol(feature) {
        const count = this._features[feature.id];
        if (!count) {
            return null;
        }
        else if (count == 1) {
            return this._defaultSymbol;
        }
        else {
            return new ClusterSymbol(count);
        }
    }
}
